import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import GlobalStyled from './modules/embed/styled/global-styled';

const EmbedChatPage = React.lazy(
  () => import('./modules/embed/pages/chat-page'),
);

export const Routes = () => (
  <Sebrae.Routes
    routes={[
      {
        routePath: '/embed/chat',
        isExactPath: true,
        pageToRender: (
          <React.Suspense fallback={<BaSeLoadingPage />}>
            <GlobalStyled />
            <EmbedChatPage />
          </React.Suspense>
        ),
      },
    ]}
  />
);
